import styled from 'styled-components';

export const ModalLopdStyles = styled.div`
  .modal-lopd {
    &-title {
      font-weight: 600;
      margin-bottom: 20px;
      font-size: 20px;
      line-height: 24px;
      margin-top: 10px;
    }
    &-text {
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 24px;
    }
    &-footer {
      margin-top: 20px;
    }

    &__section {
      &-title {
        font-weight: 600;
        font-size: 16px;
        line-height: 18px;
        margin: 20px 0;
      }
      &-text {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 24px;
        &:last-child {
          margin-bottom: 0px;
        }
      }
    }
    ol {
      list-style: auto;
    }
  }
`;
